import React from 'react';
import { Bookmark as LucideBookmark } from 'lucide-react';

interface BookmarkProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Bookmark: React.FC<BookmarkProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideBookmark width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Bookmark;
